import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  tr: {
    // Landing
    title: 'Zener Mind',
    subtitle: 'Bu test, sezgisel yeteneklerini test etmen için özel olarak tasarlanmıştır. Bu testi çözerken sakin bir alanda odaklanarak yapman daha doğru sonuçlar almanı kolaylaştıracaktır. Sezgilerin güçlü olsun, başarılar...',
    howItWorks: 'Nasıl Çalışır?',
    step1Title: 'Kart Oluşturma',
    step1Desc: 'Her testin başında kartlar önceden rastgele ve sırayla oluşturulur.',
    step2Title: 'Sembol Seçimi',
    step2Desc: 'Sezgisel olarak algıladığınız sembolü dikkatlice seçin ve tıklayın.',
    step3Title: 'Sonuç Görüntüleme',
    step3Desc: 'Kart her seçimden sonra açılır ve bilip bilmediğini gösterir.',
    step4Title: 'İlerleme Takibi',
    step4Desc: 'Sonuçlar tekrarlanan oturumlarla netlik kazanır. Geçmiş ve eğitim sekmelerini keşfedin.',
    nameLabel: 'İsim (İsteğe Bağlı)',
    namePlaceholder: 'İsminizi girin',
    cardCountLabel: 'Kart Sayısı Seçin',
    cardSuffix: 'Kart',
    beginSession: 'Oturumu Başlat',
    footerNote: 'Hızlı tahmin yapmaktan kaçının. Algının yol göstermesine izin verin.',
    premiumActive: 'Premium Aktif',
    
    // Telepathy Mode
    telepathyTitle: 'Telepati Modu',
    telepathySubtitle: 'İki kişilik sezgisel algı deneyimi',
    nickname: 'Takma adınız',
    continueBtn: 'Devam Et',
    randomMatch: 'Rastgele bir kullanıcıyla eşleşeceksiniz',
    noRegistration: 'Kayıt gerekmez, anonim kalırsınız',
    tenRounds: '10 tur telepati deneyi yapacaksınız',
    selectLocation: 'Konumunuzu seçin',
    country: 'ÜLKE',
    selectCountry: 'Ülke seçin',
    city: 'ŞEHİR',
    selectCity: 'Şehir seçin',
    findPartner: 'Partner Bul',
    searchingPartner: 'Partner Aranıyor...',
    pleaseWait: 'Lütfen bekleyin, uyumlu bir zihin aranıyor',
    cancel: 'İptal Et',
    connected: 'Bağlantı Kuruldu!',
    yourPartner: 'Partneriniz',
    from: 'Konum',
    startExperiment: 'Deneye Başla',
    
    // Meditation
    meditationRoom: 'Meditasyon Odası',
    focusIn: 'ortamında odaklanın',
    currentUsers: 'Şu anda odaklanan kişi sayısı',
    changeEnv: 'Ortam Değiştir',
    finish: 'Bitir',
    forest: 'Orman',
    beach: 'Deniz Kıyısı',
    rain: 'Yağmur',
    mountain: 'Dağ Zirvesi',
    room: 'Kapalı Oda',
    fireplace: 'Şömine',
    underwater: 'Denizaltı',
    
    // Training
    trainingHub: 'Eğitim Merkezi',
    developSkills: 'Sezgisel yeteneklerinizi geliştirin',
    zener: 'Zener',
    symbolPerception: 'Sembol Algılama',
    color: 'Renk',
    colorPerception: 'Renk Algılama',
    number: 'Rakam',
    numberPerception: 'Sayı Algılama',
    telepathy: 'Telepati',
    dualPerception: 'İkili Algılama',
    
    // Test Screen
    round: 'Tur',
    endSession: 'Oturumu Bitir',
    sessionStats: 'Oturum İstatistikleri',
    accuracy: 'Doğruluk',
    hits: 'İsabet',
    misses: 'Kaçan',
    currentStreak: 'Mevcut Seri',
    bestStreak: 'En İyi Seri',
    transparency: 'Şeffaflık',
    transparencyNote: 'Tüm kartlar oturumun başında oluşturulur. Sonuçlar seçim anında belirlenmez.',
    match: 'Bildin!',
    noMatch: 'Eşleşmedi',
    observe: 'Gözlemle',
    endSessionConfirm: 'Oturumu şimdi bitirmek istediğinizden emin misiniz? Mevcut ilerlemeniz kaydedilecek.',
    
    // Summary
    sessionComplete: 'Oturum Tamamlandı',
    finalAccuracy: 'Nihai Doğruluk',
    baseline: 'Temel çizgiden',
    totalRounds: 'Toplam Tur',
    psychicLevel: 'Mevcut Psişik Kalibrasyon Seviyesi',
    hitMissTimeline: 'İsabet/Kaçan Zaman Çizelgesi',
    symbolPerformance: 'Sembol Performansı',
    sessionInfo: 'Oturum Bilgileri',
    sessionId: 'Oturum ID',
    newSession: 'Yeni Oturum Başlat',
    
    // Navigation
    history: 'Geçmiş',
    training: 'Eğitim',
    
    // Levels
    level1: 'Rastgele Sinyal Baskınlığı',
    level2: 'Gelişmekte Olan Sezgisel Sinyal',
    level3: 'Gelişen Psişik Duyarlılık',
    level4: 'Aktif Sezgisel Algı',
    level5: 'Yüksek Algısal Tutarlılık',
    
    // Common
    loading: 'Yükleniyor...',
    back: 'Geri',
    next: 'İleri',
    start: 'Başla',
    skip: 'Atla'
  },
  en: {
    // Landing
    title: 'Zener Mind',
    subtitle: 'This test is specially designed to test your intuitive abilities. Taking this test in a calm area with focus will help you get more accurate results. May your intuition be strong, good luck...',
    howItWorks: 'How It Works?',
    step1Title: 'Card Generation',
    step1Desc: 'At the start of each test, cards are pre-generated randomly and sequentially.',
    step2Title: 'Symbol Selection',
    step2Desc: 'Carefully select and click on the symbol you intuitively perceive.',
    step3Title: 'Result Display',
    step3Desc: 'The card reveals after each selection, showing whether you were right.',
    step4Title: 'Progress Tracking',
    step4Desc: 'Results clarify with repeated sessions. Explore history and training tabs.',
    nameLabel: 'Name (Optional)',
    namePlaceholder: 'Enter your name',
    cardCountLabel: 'Select Card Count',
    cardSuffix: 'Cards',
    beginSession: 'Begin Session',
    footerNote: 'Avoid quick guesses. Let perception guide you.',
    premiumActive: 'Premium Active',
    
    // Telepathy Mode
    telepathyTitle: 'Telepathy Mode',
    telepathySubtitle: 'Two-player intuitive perception experience',
    nickname: 'Your nickname',
    continueBtn: 'Continue',
    randomMatch: 'You will be matched with a random user',
    noRegistration: 'No registration required, stay anonymous',
    tenRounds: 'You will do 10 rounds of telepathy experiments',
    selectLocation: 'Select your location',
    country: 'COUNTRY',
    selectCountry: 'Select country',
    city: 'CITY',
    selectCity: 'Select city',
    findPartner: 'Find Partner',
    searchingPartner: 'Searching Partner...',
    pleaseWait: 'Please wait, searching for a compatible mind',
    cancel: 'Cancel',
    connected: 'Connected!',
    yourPartner: 'Your partner',
    from: 'Location',
    startExperiment: 'Start Experiment',
    
    // Meditation
    meditationRoom: 'Meditation Room',
    focusIn: 'Focus in',
    currentUsers: 'Currently focusing',
    changeEnv: 'Change Environment',
    finish: 'Finish',
    forest: 'Forest',
    beach: 'Beach',
    rain: 'Rain',
    mountain: 'Mountain Peak',
    room: 'Indoor Room',
    fireplace: 'Fireplace',
    underwater: 'Underwater',
    
    // Training
    trainingHub: 'Training Center',
    developSkills: 'Develop your intuitive abilities',
    zener: 'Zener',
    symbolPerception: 'Symbol Perception',
    color: 'Color',
    colorPerception: 'Color Perception',
    number: 'Number',
    numberPerception: 'Number Perception',
    telepathy: 'Telepathy',
    dualPerception: 'Dual Perception',
    
    // Test Screen
    round: 'Round',
    endSession: 'End Session',
    sessionStats: 'Session Statistics',
    accuracy: 'Accuracy',
    hits: 'Hits',
    misses: 'Misses',
    currentStreak: 'Current Streak',
    bestStreak: 'Best Streak',
    transparency: 'Transparency',
    transparencyNote: 'All cards are generated at the start of the session. Results are not determined at selection time.',
    match: 'Got it!',
    noMatch: 'No Match',
    observe: 'Observe',
    endSessionConfirm: 'Are you sure you want to end the session now? Your current progress will be saved.',
    
    // Summary
    sessionComplete: 'Session Complete',
    finalAccuracy: 'Final Accuracy',
    baseline: 'From baseline',
    totalRounds: 'Total Rounds',
    psychicLevel: 'Current Psychic Calibration Level',
    hitMissTimeline: 'Hit/Miss Timeline',
    symbolPerformance: 'Symbol Performance',
    sessionInfo: 'Session Info',
    sessionId: 'Session ID',
    newSession: 'Start New Session',
    
    // Navigation
    history: 'History',
    training: 'Training',
    
    // Levels
    level1: 'Random Signal Dominance',
    level2: 'Emerging Intuitive Signal',
    level3: 'Developing Psychic Sensitivity',
    level4: 'Active Intuitive Perception',
    level5: 'High Perceptual Coherence',
    
    // Common
    loading: 'Loading...',
    back: 'Back',
    next: 'Next',
    start: 'Start',
    skip: 'Skip'
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('zenermind_language') || 'tr';
  });
  
  useEffect(() => {
    localStorage.setItem('zenermind_language', language);
  }, [language]);
  
  const t = (key) => {
    return translations[language][key] || key;
  };
  
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
  };
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

// Language Toggle Component
export const LanguageToggle = ({ className = '' }) => {
  const { language, toggleLanguage } = useLanguage();
  
  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 transition-all ${className}`}
      data-testid="language-toggle"
    >
      <span className={`text-sm font-medium ${language === 'tr' ? 'text-cyan-400' : 'text-slate-400'}`}>
        TR
      </span>
      <span className="text-slate-500">/</span>
      <span className={`text-sm font-medium ${language === 'en' ? 'text-cyan-400' : 'text-slate-400'}`}>
        EN
      </span>
    </button>
  );
};
